// extracted by mini-css-extract-plugin
export default {"announcements":"Y_gG p-2","announcement":"Y_gH card my-2","announcement--highlighted":"Y_gJ","announcement__list-item":"Y_gK py-1","announcement__flag":"Y_gL"};